import React from "react";
import { Box } from "@mantine/core";
import useStyles from "./style";

const StaffGreetings = ({ userName, text }) => {
  const { classes } = useStyles();
  return (
    <>
      <Box className={classes.greetingsParentClass}>
        <h1 className={classes.welcomeHeading}>{`Welcome, ${userName}`}</h1>
        <small className={classes.smallText}>{text}</small>
      </Box>
    </>
  );
};

export default StaffGreetings;
